import { render, staticRenderFns } from "./VReopen.vue?vue&type=template&id=c13bd0c6&"
import script from "./VReopen.vue?vue&type=script&lang=js&"
export * from "./VReopen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports